// Exibidas (1x por produto e lugar por visita ao cardápio) e adicionadas, em lote.
const fila = [];
const vistos = new Set();
let timer = null;

function enviar() {
  timer = null;
  if (fila.length === 0) return;
  const lote = fila.splice(0, 60);
  try {
    fetch("/api/public/sugestoes/eventos", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ eventos: lote }), keepalive: true,
    }).catch(() => {});
  } catch { /* sem rede */ }
  if (fila.length) agendar();
}

function agendar() {
  if (!timer) timer = setTimeout(enviar, 4000);
}

if (typeof document !== "undefined") {
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "hidden") enviar(); });
}

export function registrarExibidas(lugar, ids) {
  for (const id of ids || []) {
    const chave = `${lugar}:${id}`;
    if (vistos.has(chave)) continue;
    vistos.add(chave);
    fila.push({ lugar, produto_id: String(id), tipo: "exibida" });
  }
  agendar();
}

export function registrarAdicionada(lugar, id) {
  fila.push({ lugar, produto_id: String(id), tipo: "adicionada" });
  agendar();
}
